import React, { useState } from "react";
import {
    Box,
    Tabs,
    Tab,
    Paper
} from "@mui/material";

import OverviewTab from "./tabs/OverviewTab";
import TasksTab from "./tabs/TasksTab";
import ApprovalsTab from "./tabs/ApprovalsTab";
import AttachmentsTab from "./tabs/AttachmentsTab";
import CommentsTab from "./tabs/CommentsTab";
import ActivityTab from "./tabs/ActivityTab";

const ChangeTabs = ({ change }) => {

    const [activeTab, setActiveTab] = useState(0);

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    if (!change) {
        return null;
    }

    return (
        <Paper
            elevation={0}
            sx={{
                width: "100%",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden"
            }}
        >

            <Tabs
                value={activeTab}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    px: 2
                }}
            >

                <Tab label="Overview" />

                <Tab label="Tasks" />

                <Tab label="Approvals" />

                <Tab label="Attachments" />

                <Tab label="Comments" />

                <Tab label="Activity" />

            </Tabs>


            <Box sx={{ p: 3 }}>

                {activeTab === 0 && (
                    <OverviewTab
                        change={change}
                    />
                )}

                {activeTab === 1 && (
                    <TasksTab
                        change={change}
                    />
                )}

                {activeTab === 2 && (
                    <ApprovalsTab
                        change={change}
                    />
                )}

                {activeTab === 3 && (
                    <AttachmentsTab
                        change={change}
                    />
                )}

                {activeTab === 4 && (
                    <CommentsTab
                        change={change}
                    />
                )}

                {activeTab === 5 && (
                    <ActivityTab
                        change={change}
                    />
                )}

            </Box>
           
        </Paper>
    );
};

export default ChangeTabs;